import { Mode, Transport } from 'rise-wallet'
import type { Porto } from 'rise-wallet/remote'
import { http, type ValueOf } from 'viem'
import { rise, riseTestnet, sepolia } from 'viem/chains'

import * as Env from './Env'

const mock = import.meta.env.MODE === 'test'

const config = {
  anvil: {
    chains: [riseTestnet, sepolia],
    feeToken: 'ETH',
    mode: Mode.relay({
      mock,
    }),
    relay: http(Transport.relayUrls.anvil.http),
    transports: {
      [riseTestnet.id]: http(),
      [sepolia.id]: http(),
    },
  },
  prod: {
    // `chains` is generated by `scripts/chains.ts`
    chains: [rise, riseTestnet, sepolia],
    feeToken: 'ETH',
    mode: Mode.relay({
      mock,
    }),
    relay: http(Transport.relayUrls.prod.http),
    // `transports` is generated by `scripts/chains.ts`
    transports: {
      [rise.id]: http(),
      [riseTestnet.id]: http(),
      [sepolia.id]: http(),
    },
  },
  stg: {
    // `chains` is generated by `scripts/chains.ts`
    chains: [riseTestnet, sepolia],
    feeToken: 'ETH',
    mode: Mode.relay({
      mock,
    }),
    relay: http(Transport.relayUrls.stg.http),
    storageKey: 'risewallet.store.stg',
    // `transports` is generated by `scripts/chains.ts`
    transports: {
      [riseTestnet.id]: http(),
      [sepolia.id]: http(),
    },
  },
} as const satisfies Record<Env.Env, Partial<Porto.Config>>

const dialogHosts = {
  anvil: import.meta.env.PROD
    ? undefined
    : 'https://anvil.localhost:5174/dialog/',
  prod: import.meta.env.PROD
    ? 'https://wallet.risechain.com/dialog/'
    : 'https://localhost:5174/dialog/',
  stg: import.meta.env.PROD
    ? 'https://stg.wallet.risechain.com/dialog/'
    : 'https://stg.localhost:5174/dialog/',
} as const satisfies Record<Env.Env, string | undefined>

export function getConfig(
  env = Env.get(),
): Porto.Config<readonly [Chain, ...Chain[]]> {
  return config[env] as never
}

export function getDialogHost(env = Env.get()): string {
  const url = (() => {
    if (import.meta.env.VITE_DIALOG_HOST)
      return import.meta.env.VITE_DIALOG_HOST
    if (
      import.meta.env.VITE_VERCEL_ENV === 'preview' &&
      import.meta.env.VITE_VERCEL_BRANCH_URL
    )
      return (
        'https://' +
        import.meta.env.VITE_VERCEL_BRANCH_URL.replace(
          /(.*)(-git.*)/,
          'rise-wallet-testnet-dialog$2',
        ) +
        '/dialog/'
      )
    return dialogHosts[env]
  })()
  return url + '?relayEnv=' + env
}

export type Chain = ValueOf<typeof config>['chains'][number]
export type ChainId = Chain['id']
